module.exports = __webpack_public_path__ + "media/newstyle/images/icon-pocket-25601a9d23556cc32037d7e9961ef547.svg";